import { createContext, useContext, ReactNode, useState } from "react";
import { onShowLoading } from "../ui/Loading/Loading";

type LoadingContextValue = {
  showLoading: (isLoading: boolean, time?: number) => void;
};

export const LoadingContext = createContext<LoadingContextValue>({
  showLoading: () => {},
});

export function LoadingProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  function showLoading(isLoading: boolean, time?: number) {
    if (isLoading) {
      document.body.style.overflow = "hidden";
      setOpen(true);
      if (time) {
        setTimeout(() => {
          setOpen(false);
          document.body.style.overflow = "auto";
        }, time);
      }
    } else {
      setOpen(false);
      document.body.style.overflow = "auto";
    }
  }

  return (
    <LoadingContext.Provider value={{ showLoading }}>
      {children}
      {onShowLoading(open)}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const { showLoading } = useContext(LoadingContext);
  return { showLoading };
}
